
import AppCustomLangSelect from "@/components/CustomLanguageSelect.vue";
import { Condition } from "@/utils/condition/condition";
import { Field } from "@/utils/documents/field";
import Vue from "vue";
import AppFieldConditionEdit from "../models/ConditionEdit.vue";
import {getSaleInSaleLayoutPropSelectGroup} from "@/utils/prop-select/sale-in-sale-layout-prop-group";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import AppPropSelectAutocomplete from "@/components/prop-select/PropSelectAutocomplete.vue";
import { getSaleMapPropSelectGroup } from "@/utils/prop-select/sale-map-prop-group";

export default Vue.extend({
	data() {
		return {
			lang: "",
			hiddenKeys: [] as string[],
		};
	},
	props: {
		value: {
			type: Object as () => Field,
			required: true
		},
		selectedLang: String,
		title: {
			type: String,
			default():string{
				return this.$ct("edit-prop").toString();
			}
		}
	},
	computed: {
		props(): PropSelectGroup {
			return getSaleMapPropSelectGroup();
		},
		conditionProps():PropSelectGroup{
			return getSaleInSaleLayoutPropSelectGroup();
		}
	},
	watch: {
		selectedLang: {
			immediate: true,
			handler(lang: string) {
				this.lang = lang;
			}
		},
		lang(lang: string) {
			if (lang == this.selectedLang) return;
			this.$emit("update:selectedLang", lang);
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async addCondition(){
			let condition = new Condition();
			this.hiddenKeys.push(condition.key);
			this.value.Conditions.push(condition);
			await this.$nextTick();
			this.hiddenKeys.pop();
		},
		removeCondition(i:number){
			this.value.Conditions.splice(i,1);
		},
		shouldShowKey(key:string):boolean{
			return this.hiddenKeys.indexOf(key) == -1;
		}
	},
	components: {
		AppCustomLangSelect,
		AppFieldConditionEdit,
		AppPropSelectAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
